import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, sel, useBranchList } from "./shared";

export const UNASSIGNED = "__unassigned__";
// business-calendar today (Asia/Kolkata), never the device's zone
export const bizToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata" }).format(new Date());

export function useRevenueFilters(prefix) {
  const { user } = useAuth();
  const branches = useBranchList(user);
  const t = bizToday();
  const [f, setF] = useState({ preset: "month", from: t.slice(0, 8) + "01", to: t, branch: "" });
  const params = { ...(f.preset === "today" ? { on: t } : f.preset === "month" ? { from: t.slice(0, 8) + "01", to: t } : { from: f.from, to: f.to }), ...(f.branch ? { branch: f.branch } : {}) };
  const ready = f.preset !== "custom" || !!(f.from && f.to && f.from <= f.to);
  const allBranches = !user?.branch_ids?.length;
  const node = (
    <div className="flex flex-wrap items-end gap-2" data-testid={`${prefix}-filters`}>
      <div className="flex gap-1 pb-0.5">
        {[["today", "Today"], ["month", "This month"], ["custom", "Custom range"]].map(([k, l]) => (
          <Button key={k} size="sm" variant={f.preset === k ? "default" : "outline"} className={f.preset === k ? "bg-slate-900 text-white" : ""} onClick={() => setF({ ...f, preset: k })} data-testid={`${prefix}-preset-${k}`}>{l}</Button>))}
      </div>
      {f.preset === "custom" && <>
        <Field label="From"><Input type="date" className="w-40" value={f.from} max={f.to} onChange={(e) => setF({ ...f, from: e.target.value })} data-testid={`${prefix}-from`} /></Field>
        <Field label="To (included)"><Input type="date" className="w-40" value={f.to} min={f.from} onChange={(e) => setF({ ...f, to: e.target.value })} data-testid={`${prefix}-to`} /></Field></>}
      {(branches.length > 1 || allBranches) && <Field label="Branch"><select className={`${sel} w-52`} value={f.branch} onChange={(e) => setF({ ...f, branch: e.target.value })} data-testid={`${prefix}-branch`}>
        <option value="">{allBranches ? "All branches" : "All my branches"}</option>
        {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
        {allBranches && <option value={UNASSIGNED}>Unassigned (no branch recorded)</option>}
      </select></Field>}
      {!ready && <p className="pb-2 text-xs text-amber-700" data-testid={`${prefix}-range-hint`}>Choose both a start and an end date.</p>}
    </div>
  );
  return [params, node, ready];
}
